import React from 'react';
import { motion } from 'framer-motion';
import { Award, Footprints, Globe } from 'lucide-react';
export function ProofSection() {
  const proofs = [{
    icon: Award,
    title: '8+ años de experiencia',
    description: 'Acompañando procesos empresariales con orden y estructura'
  }, {
    icon: Footprints,
    title: 'Proceso guiado paso a paso',
    description: 'Para avanzar con claridad desde el inicio'
  }, {
    icon: Globe,
    title: 'Experiencia real en EE. UU.',
    description: 'Entendiendo lo que necesita un negocio para verse formal y operar mejor'
  }];
  return <section className="py-24 bg-inkova-primary text-white" data-id="element-331">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-332">
        <div className="text-center mb-16" data-id="element-333">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-inkova-accent mb-6" data-id="element-334">
            ¿Por qué confiar en&nbsp;Inkova?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-300 font-light max-w-3xl mx-auto" data-id="element-335">
            No somos una plataforma automática. No somos un formulario en línea.
            No somos una respuesta genérica&nbsp;de&nbsp;Google.
            <br data-id="element-336" />
            <br data-id="element-337" />
            <span className="font-medium text-white" data-id="element-338">
              Somos personas reales acompañando a personas&nbsp;reales.
            </span>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-339">
          {proofs.map((proof, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white/5 border border-inkova-accent/20 rounded-2xl p-6 text-center" data-id="element-340">
              <proof.icon className="w-8 h-8 text-inkova-accent mx-auto mb-4" data-id="element-341" />
              <h3 className="text-lg font-serif text-inkova-accent mb-2" data-id="element-342">
                {proof.title}
              </h3>
              <p className="text-gray-300 font-light text-sm leading-relaxed" data-id="element-343">
                {proof.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-inkova-accent/10 p-8 md:p-10 rounded-2xl border border-inkova-accent/30 text-center max-w-4xl mx-auto" data-id="element-344">
          <p className="text-xl md:text-2xl font-serif italic text-inkova-accent" data-id="element-345">
            "Entendemos lo que significa empezar desde cero en un país nuevo.
            Entendemos el idioma, la cultura y el miedo. Y entendemos
            exactamente qué necesitas&nbsp;para&nbsp;avanzar."
          </p>
        </motion.div>
      </div>
    </section>;
}